// HeaderGB.js
import React, { useEffect, useState } from 'react';
import { Header } from 'antd/lib/layout/layout';
import { Row, Col, Tooltip } from 'antd';
import moment from 'moment';
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom';
import { ReactComponent as Logo } from '../../../../assets/icons/logo.gov.svg';
import { ReactComponent as Greece2 } from '../../../../assets/icons/logo.greece2.gov.svg';
import { ReactComponent as BarChart } from '../../../../assets/icons/reports.gov.svg';
import { ReactComponent as Download } from '../../../../assets/icons/download.gov.svg';
import { Logout } from './components';
import { useSelector, useDispatch } from 'react-redux';
import { getSystemLocales } from 'store/forms/actions';
import { renderButtons } from 'components/layout/utils';
import { saveTask, submitTask, startNew } from 'store/forms/actions';
import SubmitModal from '../submitModal';
import InvalidModal from '../invalidModal';
import { getLocalString, localNames } from 'utils/localisation.service';
import {
  handleSubmit,
  isKtP,
  isBeneficiary,
  isProvider,
  isAuditor,
  isMinistry,
  isSupplier,
  isVoucherViewer,
  isVoucherAuditor,
} from 'utils';
import Button from 'components/button';
import {
  openUploadOffersModal,
  openUploadProviderModal,
} from 'store/appTrack/actions';
import { checkUniqueness } from 'store/forms/actions';
import { handleCheckUniqueness } from 'utils';
import userManualBeneficiary from '../../../../assets/documents/User Manual - Ωφελούμενων.pdf';
import userManualAuditor from '../../../../assets/documents/User Manual - Αξιολογητής.pdf';
import userManualMinistry from '../../../../assets/documents/User Manual - Χρήστης Υπουργείου.pdf';
import userManualKtP from '../../../../assets/documents/User Manual - ΚτΠ.pdf';
import userManualSupplier from '../../../../assets/documents/User Manual - Δέσμευση και Εξαργύρωση voucher.pdf';
import CancelModal from '../cancelModal';

const HeaderGB = props => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [userManual, setUserManual] = useState('');
  const user = useSelector(state => state.user);
  const iniFlag = useSelector(state => state.user.taxis_data.iniFlag);
  const privileges = user.privileges;
  const groups = user.groups;
  const submitDisabled = useSelector(state => state.forms.submitting);
  const [outcome, setOutcome] = useState('');
  const params = useParams();
  const state = useSelector(state => state.forms);
  const formId = useSelector(state => state.forms.formId);
  const task = useSelector(state => state.forms.task);
  const viewMode = useSelector(state => state.forms.carrier?.viewMode);
  const dispatch = useDispatch();
  const applStatus = useSelector(state => state.forms.applStatus);
  const navigate = useNavigate();
  const locales = useSelector(state => state.forms?.localeStrings);
  const offersFile = useSelector(state => state.appTrack?.selectedOffersFile);
  const providerFile = useSelector(
    state => state.appTrack?.selectedProviderFile
  );
  const [invalidModalVisible, setInvalidModalVisible] = useState(false);
  const checkUniquenessCreate = useSelector(
    state => state.forms.checkUniquenessCreate
  );
  const [cancelModalVisible, setCancelModalVisible] = useState(false);
  const businessKey = useSelector(state => state.forms.businessKey);

  const [rejectReasons, setRejectReasons] = useState({});

  const logoLink = user => {
    if (window.location.pathname.includes('map')) return '/';
    if (!user?.status) {
      return '/login';
    }
    return '/appTrack';
  };

  // Retrieve language from localStorage or use default
  const storedLanguage =
    localStorage.getItem('appLanguage') ||
    process.env.REACT_APP_DEFAULT_APP_LANGUAGE;
  const [language, setLanguage] = useState(storedLanguage);

  useEffect(() => {
    dispatch(getSystemLocales(language));
  }, [language, dispatch]);

  // Update localStorage whenever the language changes
  useEffect(() => {
    localStorage.setItem('appLanguage', language);
  }, [language]);

  useEffect(() => {
    if (user?.status === 200) {
      if (isBeneficiary(user?.groups)) {
        setUserManual({
          title: 'User Manual - Ωφελούμενος.pdf',
          docLink: userManualBeneficiary,
        });
      } else if (isAuditor(user?.groups)) {
        setUserManual({
          title: 'User Manual - Αξιολογητής.pdf',
          docLink: userManualAuditor,
        });
      } else if (isMinistry(user?.groups)) {
        setUserManual({
          title: 'User Manual - Χρήστης Υπουργείου.pdf',
          docLink: userManualMinistry,
        });
      } else if (isKtP(user?.groups)) {
        setUserManual({
          title: 'User Manual - ΚτΠ.pdf',
          docLink: userManualKtP,
        });
      } else if (isSupplier(user?.groups)) {
        setUserManual({
          title: 'User Manual - Δέσμευση και Εξαργύρωση voucher.pdf',
          docLink: userManualSupplier,
        });
      } else {
        setUserManual();
      }
    }
  }, [user]);

  const handleLanguageChange = lang => {
    setLanguage(lang);
  };

  return (
    <div id="header-container">
      <div id="header-content" className="main-container">
        <div className="headerGB">
          <SubmitModal
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            submitDisabled={submitDisabled}
            formKey={task.formKey}
            outcome={outcome}
            businessKey={businessKey}
            handleSubmit={() =>
              handleSubmit({
                state: { ...state },
                user: { ...user },
                task,
                dispatch,
                submitTask,
                navigate,
                setIsVisible,
                taskId: params.taskId,
                formId,
                formKey: task.formKey,
                outcome,
              })
            }
          />
          <CancelModal
            isVisible={cancelModalVisible}
            setIsVisible={setCancelModalVisible}
            submitDisabled={submitDisabled}
            formKey={task.formKey}
            outcome={outcome}
            handleSubmit={() =>
              handleSubmit({
                state: { ...state },
                user: { ...user },
                dispatch,
                submitTask,
                navigate,
                setIsVisible,
                taskId: params.taskId,
                formId,
                formKey: task.formKey,
                outcome,
              })
            }
          />
          <InvalidModal
            isVisible={invalidModalVisible}
            setVisible={setInvalidModalVisible}
            rejectReasons={rejectReasons}
            setRejectReasons={setRejectReasons}
          />
          <Row>
            <Col span={24} className="logo-header-inner">
              <div id="header-logos">
                <Link to={logoLink(user)}>
                  <Logo className="app-layout__logo-gr-2-0" />
                </Link>
                <Greece2 className="app-layout__logo-greece" />
                {user?.userId === 'admin' && (
                  <span style={{ fontSize: '1rem', color: 'white' }}>v0.1</span>
                )}
              </div>

              <div className="header-icons">
                <div id="language-menu">
                  {/* <Globe className="colored-svg white" /> */}
                  {/* <div className="header-icon">
                <div
                  className={`nav-titles ${
                    language === 'GR' ? 'selected' : ''
                  }`}
                  onClick={() => handleLanguageChange('GR')}
                >
                  gr
                </div>
              </div>*/}
                  {/* <Divider type="vertical" lineWidth="3" /> */}
                  {/* <div className="header-icon">
                <div
                  className={`nav-titles ${
                    language === 'UK' ? 'selected' : ''
                    }`}
                  onClick={() => handleLanguageChange('UK')}
                >
                  en
                </div>
              </div> */}
                  {/* <Switch checked={language === 'GR'} checkedChildren="GR" unCheckedChildren="UK" onChange={(checked) => {if (checked) {
                handleLanguageChange('GR')
              }else {
                handleLanguageChange('UK')
              }}}/> */}
                </div>
                {(isVoucherViewer(groups) || isSupplier(groups) || isVoucherAuditor(groups)) &&
                  user.status !== null &&
                  user.status !== 400 && (
                    <div
                      id="reports-icon"
                      className="header-icon container"
                      onClick={() => {
                        navigate('/reports');
                      }}
                    >
                      <Tooltip title="Reports">
                        <BarChart />
                      </Tooltip>
                    </div>
                  )}
                {user.status !== null && user.status !== 400 && (
                  <a href={userManual?.docLink} download={userManual?.title}>
                    <div
                      id="user-manual-download-icon"
                      className="header-icon container"
                      onClick={() => {
                        // apptrackService.downloadUserManual(userManual);
                        console.log('Download Manual:', userManual);
                      }}
                    >
                      <Tooltip title="User Manual">
                        <Download />
                      </Tooltip>
                    </div>
                  </a>
                )}
                {/* {user.status !== null &&
              user.status !== 400 &&
              location.pathname.includes('main-forms') && (
                <div
                  id="header-icon user-manual-download-icon"
                  className="header-icon container"
                  onClick={() => console.log('Notifications Button Clicked')}
                >
                  <Tooltip title="Notifications">
                    <Bell />
                  </Tooltip>
                </div>
              )} */}
                {privileges?.includes('CanRenderCreateApplicationBtn') &&
                  checkUniquenessCreate?.canCreate &&
                  // checkUniquenessCreate?.isAcceptedActive &&
                  // checkUniquenessCreate?.isAcceptedRegDate &&
                  location.pathname.includes('appTrack') &&
                  iniFlag === '1' && (
                    <Button
                      type="default"
                      id="create-application-button"
                      label={getLocalString(
                        locales,
                        localNames.LOGIN_PAGE_REQUESTBUTTON
                      )}
                      onClick={() => {
                        dispatch(startNew(navigate));
                      }}
                    ></Button>
                  )}
                {location.pathname.includes('main-forms') &&
                  renderButtons({
                    task,
                    state: { ...state },
                    dispatch,
                    saveTask,
                    submitTask,
                    taskId: params.taskId,
                    formId,
                    setOutcome,
                    setIsVisible,
                    setCancelModalVisible,
                    locales,
                    user: { ...user },
                    viewMode,
                    applStatus,
                    setInvalidModalVisible,
                    setRejectReasons,
                  })}
                {location.pathname.includes('appTrack') &&
                  !location.pathname.includes('offers') &&
                  isKtP(groups) && (
                    <div id="ktp-buttons-wrapper">
                      <Button
                        id="upload-offers-button"
                        type="default"
                        className="ant-btn-primary"
                        label={
                          getLocalString(
                            locales,
                            localNames?.HOME_PAGE_OFFERSBUTTON
                          ) || 'Προσφορές Παρόχων'
                        }
                        disabled={false}
                        onClick={() => navigate('/appTrack/offers')}
                      />
                    </div>
                  )}
                {location.pathname.includes('offers') && isKtP(groups) && (
                  <Button
                    type="default"
                    className="ant-btn-primary submit-btn"
                    label={getLocalString(
                      locales,
                      localNames.REQUEST_PAGE_SUBMISSIONBUTTON
                    )}
                    disabled={!offersFile}
                    onClick={() => dispatch(openUploadOffersModal(true))}
                  />
                )}
                {location.pathname.includes('appTrack') &&
                  !location.pathname.includes('provider') &&
                  isProvider(groups) && (
                    <div id="ktp-buttons-wrapper">
                      <Button
                        id="upload-offers-button"
                        type="default"
                        className="ant-btn-primary"
                        label={
                          getLocalString(
                            locales,
                            localNames?.HOME_PAGE_PROVIDER_BUTTON_STATUS
                          ) || 'Ενημέρωση Voucher Status'
                        }
                        // label={'Ενημέρωση Voucher Status'}
                        disabled={false}
                        onClick={() => navigate('/appTrack/provider')}
                      />
                    </div>
                  )}
                {location.pathname.includes('provider') &&
                  isProvider(groups) && (
                    <Button
                      type="default"
                      className="ant-btn-primary submit-btn"
                      label={getLocalString(
                        locales,
                        localNames.REQUEST_PAGE_SUBMISSIONBUTTON
                      )}
                      disabled={!providerFile}
                      onClick={() => dispatch(openUploadProviderModal(true))}
                    />
                  )}
                {user.status !== null && user.status !== 400 && (
                  <div style={{ cursor: 'pointer' }}>
                    <Logout
                      open={visible}
                      setVisible={setVisible}
                      user={user}
                    />
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default HeaderGB;
